import { Service } from '@features/service/entity';
import { WorkingDay } from '@features/visits/schedule/store';
import { useHighlightedDays } from '@features/visits/store';

export const useCustomerReservationHighlightedDays = (
  getAvailableSlots: (
    workingDay: WorkingDay,
    service: Service | undefined,
    step?: number,
  ) => { start: string; end: string }[],
) => {
  const { processDayAvailability } = useHighlightedDays(getAvailableSlots);

  return { processDayAvailability };
};
